module.exports = __webpack_public_path__ + "img/huawei.be89d173.svg";